import { render } from "./SsoCallbackView.vue?vue&type=template&id=e4d576a4"
import script from "./SsoCallbackView.vue?vue&type=script&lang=js"
export * from "./SsoCallbackView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__